export const CLOUDINARY_HOST = 'https://fiverr-res.cloudinary.com';
export const CLOUDINARY_IMAGE_OPTIMIZATION = 'f_auto,q_auto';
export const FIVERR_URL = 'https://www.fiverr.com';
